import { CommonModule } from '@angular/common';
import { Component, Input, NgModule, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { Observable } from 'rxjs';

import { HookResult, StateService, Transition, UiOnExit, UIRouterModule } from '@uirouter/angular';

import { TranslateService } from '@codeandweb/ngx-translate';

import { CalendarModule } from '@app/primeng-overrides/calendar';
import { MenuModule } from '@app/primeng-overrides/menu';
import { DividerModule } from 'primeng/divider';
import { MessageModule } from 'primeng/message';
import { PanelModule } from 'primeng/panel';
import { ToolbarModule } from 'primeng/toolbar';
import { ConfirmationService } from 'primeng/api';

import { EventManagerService } from '@app/_global/event-manager.service';
import { Abonne } from '@app/abonne/abonne.model';
import { AbonneService } from '@app/abonne/abonne.service';
import { Utilisateur } from '@app/utilisateur/utilisateur.model';
import { GlobalModule } from '@global/global.module';

import { simpleComparison } from '@app/_helpers/utils';


@Component({
	selector: 'abonne-infos-tab',
	templateUrl: `abonne-infos-tab.component.html`
})
export class AbonneInfosTabComponent implements OnInit, UiOnExit {

	@Input() me: Utilisateur;
	@Input() abonne: Abonne;

	pristineAbonne: Abonne;

	canEdit = false;
	editMode = false;
	skipExitStateCheck = false;

	constructor(
		private stateService: StateService,
		private abonneService: AbonneService,
		private eventManager: EventManagerService,
		private translate: TranslateService,
		private confirmationService: ConfirmationService,
	) {}

	ngOnInit(): void {
		this.canEdit = this.me.uti_administrateur;
		this.pristineAbonne = structuredClone(this.abonne);
	}

	toggleEditMode(status?: boolean) {
		this.editMode = (status !== undefined)? status : !!!this.editMode;
	}

	submit(){
		this.abonneService.updateAbonne(this.abonne)
		.subscribe({
			next: () => {
				this.eventManager.emit('toast', { severity: 'success', summary: 'Abonné modifié' });
				this.skipExitStateCheck = true;
				this.stateService.go('.', undefined, {reload: '^'});
			}
		})
	}

	uiCanExit(newTransition?: Transition): HookResult {
		if (!this.skipExitStateCheck && !simpleComparison(this.pristineAbonne, this.abonne)) {
			return new Observable<any>(sub => {
				this.confirmationService.confirm({
					defaultFocus: 'reject',
					header: this.translate.instant('common.leaving_unsaved_form_confirm_header'),
					message: this.translate.instant('common.leaving_unsaved_form_confirm_message'),
					accept: () => {
						sub.next(true);
						sub.complete();
					},
					reject: () => {
						sub.next(false);
						sub.complete();
					}
				});
			}).toPromise();
		}
	}

}

@NgModule({
	imports: [
		CommonModule,
		GlobalModule,
		UIRouterModule,
		FormsModule,
		CalendarModule,
		DividerModule,
		MenuModule,
		MessageModule,
		PanelModule,
		ToolbarModule,
	],
	exports: [AbonneInfosTabComponent],
	declarations: [AbonneInfosTabComponent]
})
export class AbonneInfosTabModule { }
